import { Component, Image } from '@headless-workspace/typings';
import { PropsWithClassName } from '../../../../src';
import { CardDirection, CardSize } from '../../newComposables';
import { PropsWithTestId } from '../../props';
import { GlowTile } from '../card';

type GlowOpenBarServiceTileProps = PropsWithClassName &
    PropsWithTestId & {
        title: string;
        description: string;
        href: string;
        image: Image;
    };

export const GlowOpenBarServiceTile: Component<GlowOpenBarServiceTileProps> = ({
    title,
    description,
    href,
    image,
    dataTestId,
}) => {
    return (
        <GlowTile
            size={CardSize.S}
            direction={CardDirection.Row}
            dataTestId={dataTestId}
            href={href}
            classNames={{
                width: 'w-serviceTile',
                height: 'h-serviceTileImg',
            }}
            content={{
                title: {
                    text: title,
                    className: 'line-clamp-1 text-ellipsis',
                },
                description: {
                    text: description,
                    className: 'line-clamp-2 text-ellipsis',
                },
                classNames: {
                    height: 'h-full',
                },
                className: 'pl-0.5',
            }}
            image={{
                src: image,
                classNames: {
                    image: 'object-cover h-full',
                    wrapper: '!w-auto h-serviceTileImg aspect-1/1',
                },
                loading: 'lazy',
            }}
        />
    );
};
